import { RouteConfig } from "vue-router";

export const RCompanySponsorLicence: RouteConfig = {
  path: "sponsor-licence",
  name: "companiesSponsorLicence",
  component: () =>
    import(
      /* webpackChunkName: "companies-template-sponsor-licence" */
      "./VCompanySponsorLicence.vue"
    ),
  meta: {
    label: "sponsor-licence",
    title: "Companies",
    alias: "sponsor_licence",
  },
};
